module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "editreqmodal",
    attrs: {
      "id": "edit-requirement-modal",
      "name": "edit-requirement-modal",
      "title": "Edit requirement",
      "size": "lg",
      "busy": _vm.submitting,
      "ok-title": "Update",
      "ok-disabled": !_vm.name || _vm.loading,
      "close-title": "Cancel",
      "hide-header-close": ""
    },
    on: {
      "shown": _vm.shown,
      "ok": _vm.handleOk
    }
  }, [_c('form', {
    attrs: {
      "id": "update-requirement-form"
    }
  }, [_c('b-form-group', {
    attrs: {
      "feedback": _vm.nameInvalidFeedback,
      "state": _vm.nameState
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Requirement name",
      "data-vv-name": "name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "description": "Set a custom ID for this Requirement"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Requirement ID (optional)"
    },
    model: {
      value: (_vm.displayID),
      callback: function($$v) {
        _vm.displayID = $$v
      },
      expression: "displayID"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "description": "These types can be managed on the rmCloud Configuration screen",
      "feedback": _vm.requirementTypeInvalidFeedback,
      "state": _vm.requirementTypeState
    }
  }, [_c('span', {
    attrs: {
      "id": "requirement-type-select"
    }
  }, [_c('multiselect', {
    attrs: {
      "disabled": _vm.selectedRequirements.length > 0,
      "options": _vm.requirementTypes,
      "loading": _vm.requirementTypesLoading,
      "allow-empty": false,
      "close-on-select": true,
      "hide-selected": false,
      "placeholder": "Select a requirement type",
      "label": "name",
      "track-by": "requirement_type_id"
    },
    model: {
      value: (_vm.selectedRequirementType),
      callback: function($$v) {
        _vm.selectedRequirementType = $$v
      },
      expression: "selectedRequirementType"
    }
  })], 1), _vm._v(" "), _c('b-popover', {
    attrs: {
      "target": "requirement-type-select",
      "triggers": "hover",
      "content": "To edit the requirement type, remove any linked requirements below.",
      "disabled": _vm.selectedRequirements.length === 0
    }
  })], 1), _vm._v(" "), _c('b-form-group', [_c('b-form-textarea', {
    attrs: {
      "placeholder": "Description",
      "rows": 2,
      "max-rows": 6
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), (!_vm.currentProjectIsGlobal) ? _c('b-form-group', [_c('multiselect', {
    attrs: {
      "options": _vm.statuses,
      "loading": _vm.statusesLoading,
      "close-on-select": true,
      "hide-selected": false,
      "placeholder": "Status",
      "label": "name",
      "track-by": "id"
    },
    model: {
      value: (_vm.selectedStatus),
      callback: function($$v) {
        _vm.selectedStatus = $$v
      },
      expression: "selectedStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-form-group', [_c('multiselect', {
    attrs: {
      "options": _vm.availableRequirements,
      "multiple": true,
      "loading": _vm.requirementsLoading,
      "custom-label": _vm.customRequirementLabel,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": _vm.getRequirementsPlaceholder(),
      "track-by": "requirement_id"
    },
    model: {
      value: (_vm.selectedRequirements),
      callback: function($$v) {
        _vm.selectedRequirements = $$v
      },
      expression: "selectedRequirements"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "id": "issues-multiselect-group-edit"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.sortedIssues,
      "multiple": true,
      "loading": _vm.issuesLoading,
      "custom-label": _vm.customIssueLabel,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "disabled": _vm.shouldDisableIssuesMultiselect,
      "placeholder": "Select issue(s)",
      "track-by": "id"
    },
    model: {
      value: (_vm.selectedIssues),
      callback: function($$v) {
        _vm.selectedIssues = $$v
      },
      expression: "selectedIssues"
    }
  })], 1), _vm._v(" "), (_vm.shouldDisableIssuesMultiselect) ? _c('b-tooltip', {
    attrs: {
      "target": "issues-multiselect-group-edit",
      "triggers": "hover"
    }
  }, [_vm._v("\n      No issues found on this Jira project!\n    ")]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().installed_on_confluence) ? _c('b-form-group', [_c('multiselect', {
    attrs: {
      "options": _vm.contents,
      "loading": _vm.contentsLoading,
      "multiple": true,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "max": 20,
      "placeholder": "Select Confluence content",
      "label": "title",
      "track-by": "id"
    },
    model: {
      value: (_vm.selectedContents),
      callback: function($$v) {
        _vm.selectedContents = $$v
      },
      expression: "selectedContents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.currentProjectIsGlobal) ? _c('b-form-group', [_c('multiselect', {
    attrs: {
      "options": _vm.components,
      "multiple": true,
      "loading": _vm.componentsLoading,
      "close-on-select": true,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": "Component(s)",
      "label": "name",
      "track-by": "id"
    },
    model: {
      value: (_vm.selectedComponents),
      callback: function($$v) {
        _vm.selectedComponents = $$v
      },
      expression: "selectedComponents"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.currentProjectIsGlobal) ? _c('b-form-group', [_c('multiselect', {
    attrs: {
      "options": _vm.assignees,
      "loading": _vm.assigneesLoading,
      "close-on-select": true,
      "hide-selected": false,
      "placeholder": "Assign to",
      "label": "displayName",
      "track-by": "key"
    },
    model: {
      value: (_vm.selectedAssignee),
      callback: function($$v) {
        _vm.selectedAssignee = $$v
      },
      expression: "selectedAssignee"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.attributes), function(attribute) {
    return _c('b-form-group', {
      key: attribute.attribute_id
    }, [(attribute.type === 'select') ? _c('div', [_c('label', [_vm._v(_vm._s(attribute.name))]), _vm._v(" "), _c('b-form-select', {
      attrs: {
        "options": _vm.getOptionsArray(attribute.options)
      },
      model: {
        value: (_vm.requirement.attributes[attribute.attribute_id]),
        callback: function($$v) {
          _vm.$set(_vm.requirement.attributes, attribute.attribute_id, $$v)
        },
        expression: "requirement.attributes[attribute.attribute_id]"
      }
    })], 1) : _c('b-form-input', {
      attrs: {
        "type": "text",
        "placeholder": attribute.name
      },
      model: {
        value: (_vm.requirement.attributes[attribute.attribute_id]),
        callback: function($$v) {
          _vm.$set(_vm.requirement.attributes, attribute.attribute_id, $$v)
        },
        expression: "requirement.attributes[attribute.attribute_id]"
      }
    })], 1)
  })], 2), _vm._v(" "), (_vm.submitting) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Updating\n  ")], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15be2719"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/EditRequirementModal.vue
// module id = 1000
// module chunks = 1